module.exports = __webpack_public_path__ + "static/media/multiply.f41425ed.svg";